// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"970ba1c2","455":"e1cf75e8","977":"6dedfd4e","993":"b73b815f"}[chunkId] + ".chunk.js";
};